import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Input, Button, Space, Select, Form, DatePicker, Row, Col, message, TreeSelect } from 'antd'
import { useForm } from "antd/lib/form/Form"
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons'
import { axiosHandleEvent, baseAxiosNoInfo } from "../../tool/axios"
import { formItemLayout, tailLayout } from '../../js/globalParam'
import Moment from 'moment'
import _ from 'lodash'

const { Option } = Select

type dpOptionRowType = {
    parent_id: null | string, department_id: string, department_name: string, children: [] | null
}

export default function PersonnelManageEdit() {

    const { id }: { id: string | undefined } = useParams()
    const [form] = useForm()

    const [pageTitle, setPageTitle] = useState<string>('')

    const [departMentOptions, setDepOption] = useState<any[]>([])
    const [positionOptions, setPositionOptions] = useState<any>([])

    useEffect(() => {
        // 查询全局组织
        baseAxiosNoInfo('/manpower_center/department/tree_list').then((res: any) => {
            res && setDepOption(res)
        })

        // 查询全局职位
        baseAxiosNoInfo('/global/position_list').then((res: any) => {
            res && setPositionOptions(res)
        })

        if (id) {
            baseAxiosNoInfo('/manpower_center/employee/detail', { params: { id } }).then((res: any) => {
                if (res) {
                    form.setFieldsValue({
                        ...res,
                        in_date: Moment(res.in_date),
                        out_date: res.out_date ? Moment(res.out_date) : null
                    })
                }
            })

            setPageTitle('编辑员工')

        } else {
            setPageTitle('新增员工')
        }
    }, [])

    const onFinish = (values: any) => {
        let url = id ? '/manpower_center/employee/update' : '/manpower_center/employee/add'

        axiosHandleEvent.post(url, {
            id,
            ...values,
            "in_date": values.in_date.format('YYYY-MM-DD h:mm:ss'),
            out_date: values.out_date ? values.out_date.format('YYYY-MM-DD') : null
        })
    }

    type dpRowType = { department_id: string, position_id: string, department_id_array?: string[], parent_id: null | string }

    type DepartmentPositionsProp = {
        value?: dpRowType[]
        onChange?: (value: dpRowType[]) => void
    }

    const DepartmentPositions: React.FC<DepartmentPositionsProp> = ({ value = [], onChange }) => {
        let pids: string[] = [] // 父级部门id数组
        let dpRow = {
            department_id: '', position_id: '', department_id_array: [], parent_id: null
        }

        const [data, setData] = useState<dpRowType[]>([{ ...dpRow }])

        function recursion(arr: dpOptionRowType[], departmentID: string) {
            arr?.forEach((el: dpOptionRowType) => {
                if (el.department_id === departmentID) {
                    if (el.parent_id) {
                        pids.unshift(el.parent_id)
                        recursion(departMentOptions, el.parent_id)
                    }

                } else {
                    if (el.children) {
                        recursion(el.children, departmentID)
                    }
                }
            })
        }

        useEffect(() => {
            if (value.length > 0) {
                let newValue = _.cloneDeep(value)
                setData(newValue)
            }

        }, [value])

        const handleDelete = (index: number) => {
            if (data.length !== 1) {
                let d = _.cloneDeep(data)
                d.splice(index, 1)
                setData(d)
                toggleValue(d)

            } else {
                message.error('最少要有一个组织-职位')
            }
        }

        const handleAdd = () => {
            let d = _.cloneDeep(data)
            d.push(dpRow)

            toggleValue(d)
            setData(d)
        }

        const handleInputChange = (index: number, v: any, attr: string) => {
            let d: any[] = _.cloneDeep(data)
            d[index][attr] = v

            toggleValue(d)
            setData(d)
        }

        const toggleValue = (newData: dpRowType[]) => {
            onChange?.(newData)
        }

        const recursionChildren = (children: any[]) => {
            let childArr: any = []

            children.forEach((el: any) => {
                childArr.push({
                    title: el.department_name,
                    value: el.department_id,
                    key: el.department_id,
                    children: el.children && recursionChildren(el.children)
                })
            })

            return childArr
        }

        return <div>
            <ul style={{ listStyle: 'none', marginLeft: 0, paddingLeft: 0 }}>
                {data.map((el: dpRowType, index: number) => <li style={{ marginBottom: 6 }}>
                    <Row gutter={8}>
                        <Col span={12}>
                            <TreeSelect virtual={true} treeData={recursionChildren(departMentOptions)} placeholder="组织" showSearch value={data[index]['department_id']}
                                onChange={(v: any) => { handleInputChange(index, v, 'department_id') }}
                                filterTreeNode={(inputValue: any, treeNode: any) => (treeNode.title.indexOf(inputValue) != -1)}
                            />
                        </Col>

                        <Col span={11}>
                            <Select value={data[index]['position_id']} placeholder="职位" showSearch
                                onChange={(v: any) => { handleInputChange(index, v, 'position_id') }}
                                filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                            >
                                {positionOptions.map((el: { position_id: string, position_name: string }) => <Option value={el.position_id} key={el.position_id}>{el.position_name}</Option>)}
                            </Select>
                        </Col>

                        <Col span={1}><DeleteOutlined onClick={() => { handleDelete(index) }} style={{ lineHeight: '34px' }} /></Col>
                    </Row>
                </li>)}
            </ul>

            <Button size="small" style={{ display: 'block', width: '100%' }} onClick={handleAdd}><PlusOutlined /></Button>
        </div>
    }

    const dpValidator = (_: any, value: any) => {
        if (!value) {
            return Promise.reject('至少要选择一个组织-职位，且组织和职位为必填')
        }

        let isFill = value.every((el: dpRowType) => el.department_id.length > 0 && el.position_id.length > 0)

        if (value.length > 0 && isFill) {
            return Promise.resolve()

        } else {
            return Promise.reject('每个组织和职位为必填项')
        }
    }

    const phoneValidator = (_: any, value: any) => {
        if (!value) {
            return Promise.reject('手机号必填')
        }

        if (/^1[3456789]\d{9}$/.test(value)) {
            return Promise.resolve()

        } else {
            return Promise.reject('输入11位手机号')
        }
    }

    return (<div className="common-level2-edit">
        {/* 人力中心 -> 员工及角色 -> 员工管理 -> 新增或编辑 */}
        <h2>{pageTitle}</h2>

        <div className="common-main">
            <Form {...formItemLayout} form={form} name="basic" onFinish={onFinish} >
                <Form.Item label="员工工号" name="employee_num" rules={[{ required: true, message: '请输入工号' }]}>
                    <Input style={{ width: 250 }} />
                </Form.Item>

                <Form.Item label="员工姓名" name="user_name" rules={[{ required: true, message: '请输入姓名' }]}>
                    <Input style={{ width: 250 }} />
                </Form.Item>

                <Form.Item label="员工手机号" name="phone" rules={[{ required: true, validator: phoneValidator }]}>
                    <Input style={{ width: 250 }} />
                </Form.Item>

                <Form.Item label="员工年龄" name="age" rules={[{ required: true, message: '请输入年龄' }]} >
                    <Input type="number" min="1" max="99" style={{ width: 250 }} />
                </Form.Item>

                <Form.Item label="员工性别" name="sex" rules={[{ required: true, message: '请选择性别' }]}>
                    <Select style={{ width: 155 }}>
                        <Option value={1} key="1">男</Option>
                        <Option value={2} key="2">女</Option>
                    </Select>
                </Form.Item>

                <Form.Item label="员工类型" name="in_out" rules={[{ required: true, message: '请选择员工类型' }]}>
                    <Select style={{ width: 155 }}>
                        <Option value={1} key="1">内部员工</Option>
                        <Option value={2} key="2">合作商员工</Option>
                    </Select>
                </Form.Item>

                <Form.Item label="员工状态" name="status" rules={[{ required: true, message: '必须选择状态' }]}>
                    <Select style={{ width: 155 }}>
                        <Option value={1} key="1">在职</Option>
                        <Option value={2} key="2">离职</Option>
                    </Select>
                </Form.Item>

                <Form.Item label="入职时间" name="in_date" rules={[{ required: true, message: '请选择入职时间' }]} >
                    <DatePicker />
                </Form.Item>

                <Form.Item label="离职日期" name="out_date">
                    <DatePicker />
                </Form.Item>

                <Form.Item
                    label="是否系统用户" name="is_sys_user" rules={[{ required: true, message: '请选择是否系统用户' }]}>
                    <Select style={{ width: 155 }}>
                        <Option value={1} key="1">是</Option>
                        <Option value={0} key="0">否</Option>
                    </Select>
                </Form.Item>

                <Form.Item required label="组织-职位" name="department_position_list" rules={[{ validator: dpValidator }]}>
                    <DepartmentPositions />
                </Form.Item>

                <Form.Item {...tailLayout}>
                    <Space>
                        <Button type="primary" htmlType="submit">提交</Button>
                        <Button onClick={() => { window.history.go(-1) }} >返回</Button>
                    </Space>
                </Form.Item>
            </Form>
        </div>
    </div>)
}